import React from 'react';
import PropTypes from 'prop-types';

const Rows = ({ label, minus, value, ...rest }) => (
  <tr {...rest}>
    <td style={{ width: '100%' }}></td>
    <td style={{ whiteSpace: 'nowrap' }}>{label}</td>
    <td style={{ paddingLeft: '2em' }}>{minus ? '-' : ''}</td>
    <td style={{ paddingLeft: '0.75em' }}>{value}</td>
  </tr>
);

Rows.propTypes = {
  label: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  minus: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.node, PropTypes.string])
};

export default Rows;



// WEBPACK FOOTER //
// ./webpack/components/Elements/SummaryTotals/Row.js